import { tsValidateArray, tsValidateDBPointer, tsValidateDynamicObject, tsValidateString, tsValidateUniqueId, tsValidateValue } from '@nu-art/ts-common';
import { referencableTypes } from './types.js';
import { DBDef_Variable } from '../variable/index.js';
import { DBDef_Value } from '../value/index.js';
import { DBDef_Tag } from '../tag/index.js';
import { Validator_ReferencablePrototypes } from '../../_enum/referencable/index.js';
const Validator_ModifiableProps = {
    dbRefs: tsValidateArray(tsValidateDBPointer([DBDef_Variable, DBDef_Value, DBDef_Tag]), false),
    label: tsValidateString(),
    type: tsValidateArray(tsValidateValue([...referencableTypes])),
    extends: tsValidateArray(tsValidateString()),
    prototypes: Validator_ReferencablePrototypes,
    properties: tsValidateDynamicObject(tsValidateArray(tsValidateUniqueId), tsValidateUniqueId),
};
const Validator_GeneratedProps = {};
export const DBDef_Referencable = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: 'referencable',
    entityName: 'referencable',
    frontend: {
        group: 'ts-default',
        name: 'referencable'
    },
    backend: {
        name: 'referencable'
    }
};
//# sourceMappingURL=db-def.js.map